import * as types from '../actions/ActionTypes';
import Helper from '../functions/Helper.js'

const initialState={
  favs:[],
  likes:[],
  last_visit:0,
  displayStyle:0,
  sortStylesBy:0,
  jwt:null,
  user:null,
  rehydrated:false,
  status:"UNKNOWN",
}

export default function data(state = initialState, action = {}) {
  switch (action.type) {
    case types.ADDFAV:
    {
      Helper.gaEvent("reviews","add_fav",action.value.shoe_name);
      if(state.favs.filter((x)=>x===action.value.shoe_id).length===0){
        return{
          ...state,
          favs:[...state.favs,action.value.shoe_id]
        }
      }
      else{
        return{
          ...state,
        }
      }
    }
    case types.REMOVEFAV:
    {
      Helper.gaEvent("reviews","remove_fav",action.value.shoe_name);
      return{
        ...state,
        favs:state.favs.filter((x)=>x!==action.value.shoe_id)
      }
    }
    case types.ADD_LIKE:
    {
      return{
        ...state,
        likes:[...state.likes,action.value],
      }

    }
    case types.DELETE_LIKE:
    {
      return{
        ...state,
        likes:state.likes.filter((like)=>like.style_id!=action.value)
      }
    }
    case types.LASTVISIT:
    {
      let now=new Date();
      return{
        ...state,
        last_visit:now
      }
    }
    case types.SETFILTERSTYLE:
      return {
        ...state,
        displayStyle:action.value
      };

    case types.SETSORTESTYLESBY:
      return {
        ...state,
        sortStylesBy:action.value
      };

    case types.LOGIN:
      return {
        ...state,
        jwt:action.value.token,
        user:{...Helper.parseJwt(action.value.token)},
        status:"LOGGED_IN",
      };

    case types.LOGOUT:
      return {
        ...state,
        jwt:null,
        user:null,
        status:"LOGGED_OUT",
      };

    case types.REHYDRATION_FINISHED:
      return {
        ...state,
        rehydrated:true
      };

    default:
      return state;
    }
  }
